var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHobby(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 44.328,
    height: 46,
    viewBox: "0 0 44.328 46",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3377",
    "data-name": "Group 3377",
    transform: "translate(520.966 -99.29)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4710",
    "data-name": "Path 4710",
    d: "M-254.339,258.087v.532c0,3.712.006,7.424-.013,11.136a1.184,1.184,0,0,1-.3.748c-1.275,1.313-2.573,2.6-3.879,3.886a.908.908,0,0,1-.562.259c-2.566.017-5.132.011-7.7.01-.079,0-.159-.013-.283-.024a3.326,3.326,0,0,0-.678-4.083,3.445,3.445,0,0,0,1.094-2.473,3.4,3.4,0,0,0-1.105-2.45,3.4,3.4,0,0,0,1.1-2.456,3.3,3.3,0,0,0-1.1-2.458l.672-.832c1.269,2.5,3.165,4.053,6.1,4.1V262.39c-.419-.067-.841-.1-1.248-.2a4.9,4.9,0,0,1-3.253-2.756,10.847,10.847,0,0,1-1.169-4.884c-.011-2.942,0-5.885,0-8.827,0-1.239.232-1.549,1.406-1.912.277-.085.553-.172.831-.255.68-.2.911-.063,1.031.621.177,1.008.341,2.018.524,3.025.372,2.047.746,4.094,1.141,6.137a1.371,1.371,0,0,0,.351.657q1.5,1.545,3.048,3.048a1.54,1.54,0,0,0,.7.369C-256.56,257.65-255.488,257.853-254.339,258.087Z",
    transform: "translate(-227.203 -129.373)",
    fill: "#febaba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4711",
    "data-name": "Path 4711",
    d: "M-394.435,374.549c-1.592,0-3.183,0-4.774,0a1.654,1.654,0,0,1-1.768-1.655,1.645,1.645,0,0,1,1.743-1.625q4.826-.005,9.652,0a1.65,1.65,0,0,1,1.744,1.627,1.654,1.654,0,0,1-1.77,1.653C-391.218,374.552-392.826,374.549-394.435,374.549Z",
    transform: "translate(-107.668 -244.049)",
    fill: "#febaba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4712",
    "data-name": "Path 4712",
    d: "M-120.652,387.525h3.223v11.431h-3.223Z",
    transform: "translate(-359.209 -258.638)",
    fill: "#febaba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4713",
    "data-name": "Path 4713",
    d: "M-379.206,419.27c1.318,0,2.635,0,3.953,0a1.654,1.654,0,0,1,1.772,1.65,1.659,1.659,0,0,1-1.793,1.63q-3.953,0-7.906,0a1.659,1.659,0,0,1-1.8-1.626,1.658,1.658,0,0,1,1.817-1.655Q-381.183,419.268-379.206,419.27Z",
    transform: "translate(-122.026 -287.123)",
    fill: "#febaba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4714",
    "data-name": "Path 4714",
    d: "M-511.116,272.24a.789.789,0,0,1-.79.787,3.339,3.339,0,0,0-3.325,3.333.785.785,0,0,1-.8.781.79.79,0,0,1-.826-.8,3.328,3.328,0,0,0-3.295-3.309.8.8,0,0,1-.819-.812.794.794,0,0,1,.815-.815,3.329,3.329,0,0,0,3.3-3.306.79.79,0,0,1,.823-.806.824.824,0,0,1,.809.828,3.276,3.276,0,0,0,3.261,3.278A.824.824,0,0,1-511.116,272.24Zm-4.938,1.135,1.189-1.156L-516,271.073l-1.239,1.107Z",
    transform: "translate(0 -150.75)",
    fill: "#febaba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4715",
    "data-name": "Path 4715",
    d: "M-260.06,99.29a.789.789,0,0,1,.828.8,3.332,3.332,0,0,0,3.293,3.31.8.8,0,0,1,.82.81.794.794,0,0,1-.815.816,3.33,3.33,0,0,0-3.3,3.305.792.792,0,0,1-.823.807.824.824,0,0,1-.808-.828,3.27,3.27,0,0,0-3.261-3.278.825.825,0,0,1-.845-.843.824.824,0,0,1,.84-.8,3.275,3.275,0,0,0,3.266-3.274A.823.823,0,0,1-260.06,99.29Zm1.18,4.918-1.149-1.167-1.176,1.119,1.114,1.234Z",
    transform: "translate(-229.71)",
    fill: "#febaba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4716",
    "data-name": "Path 4716",
    d: "M-390.053,135.13c1.261-1.255,2.5-2.522,3.781-3.747a1.16,1.16,0,0,1,1.764.167,2.283,2.283,0,0,1,.2,2.876c-.465.692-.465.8,0,1.5a2.28,2.28,0,0,1-.208,2.875,1.122,1.122,0,0,1-1.718.174C-387.52,137.736-388.756,136.441-390.053,135.13Z",
    transform: "translate(-117.471 -28.497)",
    fill: "#febaba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4717",
    "data-name": "Path 4717",
    d: "M-437.633,106.131c-1.28-1.284-2.533-2.516-3.756-3.778a1.172,1.172,0,0,1,.121-1.765,2.339,2.339,0,0,1,2.924-.216c.687.473.775.474,1.452.008a2.315,2.315,0,0,1,2.955.243,1.153,1.153,0,0,1,.08,1.732C-435.078,103.619-436.34,104.843-437.633,106.131Z",
    transform: "translate(-71.095 -0.6)",
    fill: "#febaba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4718",
    "data-name": "Path 4718",
    d: "M-437.309,182.169c1.357,1.349,2.607,2.564,3.824,3.812a1.136,1.136,0,0,1-.048,1.727,2.309,2.309,0,0,1-2.913.3c-.784-.516-.784-.516-1.533-.017a2.322,2.322,0,0,1-2.847-.188,1.2,1.2,0,0,1-.146-1.847C-439.774,184.692-438.55,183.45-437.309,182.169Z",
    transform: "translate(-71.451 -74.369)",
    fill: "#febaba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4719",
    "data-name": "Path 4719",
    d: "M-466.791,135.454c-1.279,1.273-2.494,2.5-3.728,3.7a1.181,1.181,0,0,1-1.81-.041,2.281,2.281,0,0,1-.225-2.952c.428-.612.428-.792,0-1.411a2.289,2.289,0,0,1,.292-3.027,1.1,1.1,0,0,1,1.681-.027C-469.317,132.922-468.08,134.173-466.791,135.454Z",
    transform: "translate(-43.049 -28.743)",
    fill: "#febaba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4720",
    "data-name": "Path 4720",
    d: "M-364.052,470.538c-1.061,0-2.122,0-3.183,0a1.652,1.652,0,0,1-1.743-1.629,1.641,1.641,0,0,1,1.717-1.651q3.209-.008,6.417,0a1.644,1.644,0,0,1,1.718,1.652,1.653,1.653,0,0,1-1.744,1.627C-361.93,470.542-362.991,470.538-364.052,470.538Z",
    transform: "translate(-136.381 -330.18)",
    fill: "#febaba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4721",
    "data-name": "Path 4721",
    d: "M-350.8,227.867h-1.637c-.11-5.35-1.351-10.255-5.387-14.127.141-.2.3-.421.453-.641s.3-.409.507-.7C-352.308,216.593-350.93,221.947-350.8,227.867Z",
    transform: "translate(-146.386 -101.499)",
    fill: "#febaba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4722",
    "data-name": "Path 4722",
    d: "M-348.852,515.255c.8,0,1.609-.008,2.413,0a1.644,1.644,0,0,1,1.67,1.648,1.643,1.643,0,0,1-1.689,1.629q-2.413.012-4.826,0a1.643,1.643,0,0,1-1.695-1.624,1.644,1.644,0,0,1,1.714-1.654C-350.461,515.25-349.656,515.255-348.852,515.255Z",
    transform: "translate(-150.738 -373.25)",
    fill: "#febaba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4723",
    "data-name": "Path 4723",
    d: "M-287.133,107.664v1.569h-1.594v-1.569Z",
    transform: "translate(-208.392 -7.514)",
    fill: "#febaba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4724",
    "data-name": "Path 4724",
    d: "M-288.717,203.5h1.576v1.585h-1.576Z",
    transform: "translate(-208.401 -93.507)",
    fill: "#febaba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4725",
    "data-name": "Path 4725",
    d: "M-519.11,235.515V237.1h-1.59v-1.581Z",
    transform: "translate(-0.239 -122.237)",
    fill: "#febaba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4726",
    "data-name": "Path 4726",
    d: "M-399.147,283.65v1.572h-1.594V283.65Z",
    transform: "translate(-107.88 -165.429)",
    fill: "#febaba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4727",
    "data-name": "Path 4727",
    d: "M-352.744,315.472h1.581v1.59h-1.581Z",
    transform: "translate(-150.949 -193.984)",
    fill: "#febaba"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHobby);
export default __webpack_public_path__ + "static/media/Hobby.26368a12b89bd6a50b01f413e91c6395.svg";
export { ForwardRef as ReactComponent };